import { render, staticRenderFns } from "./ContentNodeEditorBackButton.vue?vue&type=template&id=1565d6c6&scoped=true&"
import script from "./ContentNodeEditorBackButton.vue?vue&type=script&lang=js&"
export * from "./ContentNodeEditorBackButton.vue?vue&type=script&lang=js&"
import style0 from "./ContentNodeEditorBackButton.vue?vue&type=style&index=0&id=1565d6c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565d6c6",
  null
  
)

export default component.exports